import React, { createContext, useContext } from 'react';

import { finleyAssert } from '@finley-technologies/common';
import { DataPipeline } from '@finley-technologies/finley-types';

import {
  isNeededInput,
  NeededInput,
} from 'packages/dataPipeline/ui/uploads/neededInput';

// wrapped so that "no input is needed" (null) differs from "no provider"
const NeededInputContext = createContext<{
  neededInput: NeededInput | null;
} | null>(null);

export const NeededInputProvider = ({
  neededInput,
  children,
}: {
  neededInput: NeededInput | null;
  children: React.ReactNode;
}): React.ReactElement => (
  <NeededInputContext.Provider value={{ neededInput }}>
    {children}
  </NeededInputContext.Provider>
);

// the input the caller needs uploaded, or null when it needs none in particular
export const useNeededInput = (): NeededInput | null => {
  const context = useContext(NeededInputContext);
  finleyAssert(
    context,
    'useNeededInput must be used within a NeededInputProvider.',
  );
  return context.neededInput;
};

// is this drawer input the one the caller needs uploaded?
export const useIsNeededInput = ({
  meshInput,
  artifact,
}: {
  meshInput: DataPipeline.MeshInput;
  artifact: DataPipeline.Artifact;
}): boolean => {
  const neededInput = useNeededInput();
  return (
    neededInput !== null && isNeededInput({ neededInput, meshInput, artifact })
  );
};
